import { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DefaultStatisticsCard from "./components/RecvCard";
import {
  pickedQtyColumns,
  orderQtyColumns,
  pickDOColumns,
  pickDOManifestColumns,
  pickDOWithCancelColumns,
  pickDOManifestWithCancelColumns,
  allColumns,
} from "./components/columns";
import { useQuery } from "@tanstack/react-query";
import { ListLayout } from "ui-components/Layout";
import { TableCard } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { useCustomerValue } from "providers/CustomerContext";
import { getSalesDashboardStatusCount, getSalesDashboard } from "services/data.dashboard.service";
import { SelectFields } from "ui-components/Form";
import { filterSalesByCustOrdNbr } from "services/data.dashboard.service";
import { TextField } from "@mui/material";
import { LoadingDialog } from "ui-components/Alert";
import { exportNoStock, exportAllSalesDashboard } from "services/data.dashboard.service";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { ExportDialog } from "ui-components/Alert";

function SalesDashboard() {
  //filter by customer code
  const { customerCode } = useCustomerValue();
  const enabled = Boolean(customerCode);
  const [dashboardType, setDashboardType] = useState("picking-unassigned");
  const [columns, setColumns] = useState(orderQtyColumns);
  const [data, setData] = useState([]);
  const [custOrdNbrs, setCustOrdNbrs] = useState("");
  const [clicked, setClicked] = useState(false);
  const { downloadCsv, isDownloading } = useCsvDownloadHook();
  const [isNoStockExporting, setIsNoStockExporting] = useState(false);
  const [isExportingAll, setIsExportingAll] = useState(false);

  let currentDate = new Date();
  const [dateEnd, setDateEnd] = useState(new Date(currentDate));
  const [dateEndDefault, setDateEndDefault] = useState(null);

  const [dateStart, setDateStart] = useState(
    new Date(currentDate.setDate(currentDate.getDate() - 1))
  );
  const [dateStartDefault, setDateStartDefault] = useState(null);

  const [tabs, setTabs] = useState([
    { label: "Completed", count: 0 },
    { label: "Cancelled", count: 0 },
    { label: "PickingUnassigned", count: 0 },
    { label: "PickingAssignedSingle", count: 0 },
    { label: "PickingAssignedWave", count: 0 },
    { label: "Packing", count: 0 },
    { label: "AwaitingDispatch", count: 0 },
    { label: "OutFromWarehouse", count: 0 },
    { label: "NoStock", count: 0 },
  ]);
  const [filterMethod, setFilterMethod] = useState("Order Date");
  const [filteredData, setFilteredData] = useState([]);

  const { isFetching, refetch } = useQuery({
    queryKey: ["sales-dashboard", { dashboardType, customerCode }],
    enabled: enabled && dashboardType !== "filterCustOrdNbr",
    queryFn: () =>
      getSalesDashboard({
        filterMethod: filterMethod,
        dashboardType: dashboardType,
        dateStart: Boolean(dateStartDefault) ? dayjs(dateStartDefault).format("YYYY-MM-DD") : null,
        // dateStart: defaultDate ?
        //   (Boolean(dateStartDefault) ? dayjs(dateStartDefault).format("YYYY-MM-DD") : null) :
        //   (Boolean(dateStart) ? dayjs(dateStart).format("YYYY-MM-DD") : null),
        dateEnd: Boolean(dateEndDefault) ? dayjs(dateEndDefault).format("YYYY-MM-DD") : null,
        // dateEnd: defaultDate ?
        // (Boolean(dateEndDefault) ? dayjs(dateEndDefault).format("YYYY-MM-DD") : null) :
        // (Boolean(dateEnd) ? dayjs(dateEnd).format("YYYY-MM-DD") : null),
        dateStart2: Boolean(dateStart) ? dayjs(dateStart).format("YYYY-MM-DD") : null,
        dateEnd2: Boolean(dateEnd) ? dayjs(dateEnd).format("YYYY-MM-DD") : null,
        customerCode: customerCode,
      }),
    onSuccess: (data) => {
      if (data.data.data) {
        setData(data.data.data);
        setFilteredData(data.data.data);
      } else {
        setData([]);
        setFilteredData([]);
      }
      refetch2();
    },
  });
  const { isFetching: isFetching2, refetch: refetch2 } = useQuery({
    queryKey: ["sales-dashboard-status", customerCode],
    enabled: enabled,
    queryFn: () =>
      getSalesDashboardStatusCount({
        filterMethod: filterMethod,
        dateStart: Boolean(dateStartDefault) ? dayjs(dateStartDefault).format("YYYY-MM-DD") : null,
        // dateStart: defaultDate ?
        //   (Boolean(dateStartDefault) ? dayjs(dateStartDefault).format("YYYY-MM-DD") : null) :
        //   (Boolean(dateStart) ? dayjs(dateStart).format("YYYY-MM-DD") : null),
        dateEnd: Boolean(dateEndDefault) ? dayjs(dateEndDefault).format("YYYY-MM-DD") : null,
        // dateEnd: defaultDate ?
        // (Boolean(dateEndDefault) ? dayjs(dateEndDefault).format("YYYY-MM-DD") : null) :
        // (Boolean(dateEnd) ? dayjs(dateEnd).format("YYYY-MM-DD") : null),
        dateStart2: Boolean(dateStart) ? dayjs(dateStart).format("YYYY-MM-DD") : null,
        dateEnd2: Boolean(dateEnd) ? dayjs(dateEnd).format("YYYY-MM-DD") : null,
        customerCode: customerCode,
      }),
    onSuccess: (data) => {
      if (data.data.data) setTabs(data.data.data);
      else
        setTabs([
          { label: "Completed", count: 0 },
          { label: "Cancelled", count: 0 },
          { label: "PickingUnassigned", count: 0 },
          { label: "PickingAssignedSingle", count: 0 },
          { label: "PickingAssignedWave", count: 0 },
          { label: "Packing", count: 0 },
          { label: "AwaitingDispatch", count: 0 },
          { label: "OutFromWarehouse", count: 0 },
          { label: "NoStock", count: 0 },
        ]);
    },
  });

  const { isFetching: isFetching3, refetch: refetch3 } = useQuery({
    queryKey: ["sales-filter-cust-ord-nbr", customerCode],
    enabled: enabled && dashboardType === "filterCustOrdNbr" && Boolean(custOrdNbrs) && clicked,
    queryFn: () =>
      filterSalesByCustOrdNbr({
        customerCode: customerCode,
        custOrdNbrs: custOrdNbrs,
      }),
    onSuccess: (data) => {
      if (data.data.data) {
        setData(data.data.data);
        setFilteredData(data.data.data);
      } else {
        setData([]);
        setFilteredData([]);
      }
      refetch2();
    },
  });

  const defaultDate =
    dashboardType === "picking-unassigned" ||
    dashboardType === "picking-assigned-single" ||
    dashboardType === "picking-assigned-wave" ||
    dashboardType === "packing" ||
    dashboardType === "no-stock" ||
    dashboardType === "filterCustOrdNbr";

  const setBothStartDate = (date) => {
    setDateStartDefault(date);
    setDateStart(date);
  };
  const setBothEndDate = (date) => {
    setDateEndDefault(date);
    setDateEnd(date);
  };
  const customProps = {
    startDate: defaultDate ? dateStartDefault : dateStart,
    setStartDate: setBothStartDate,
    endDate: defaultDate ? dateEndDefault : dateEnd,
    setEndDate: setBothEndDate,
  };
  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };

  const handleClick = (type, column) => {
    if (dashboardType != type) setData([]);
    setDashboardType(type);
    setColumns(column);
  };

  const handleNoStockExportClick = async () => {
    try {
      setIsNoStockExporting(true);
      const response = await exportNoStock({
        customerCode,
        dateStart: Boolean(dateStartDefault) ? dayjs(dateStartDefault).format("YYYY-MM-DD") : null,
        dateEnd: Boolean(dateEndDefault) ? dayjs(dateEndDefault).format("YYYY-MM-DD") : null,
        filterMethod,
      });
      const blob = new Blob([response.data], { type: response.headers["content-type"] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_Sales_${dashboardType}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => {
        setIsNoStockExporting(false);
        URL.revokeObjectURL(url); // Cleanup
      }, 2000);
    } catch (error) {}
  };

  const handleExportAllClick = async () => {
    try {
      setIsExportingAll(true);
      const response = await exportAllSalesDashboard({
        customerCode,
        dateStart: Boolean(dateStartDefault) ? dayjs(dateStartDefault).format("YYYY-MM-DD") : null,
        dateEnd: Boolean(dateEndDefault) ? dayjs(dateEndDefault).format("YYYY-MM-DD") : null,
        dateStart2: Boolean(dateStart) ? dayjs(dateStart).format("YYYY-MM-DD") : null,
        dateEnd2: Boolean(dateEnd) ? dayjs(dateEnd).format("YYYY-MM-DD") : null,
        filterMethod,
      });
      const blob = new Blob([response.data], { type: response.headers["content-type"] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_Sales_All.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => {
        setIsExportingAll(false);
        URL.revokeObjectURL(url); // Cleanup
      }, 2000);
    } catch (error) {
      setIsExportingAll(false);
    }
  };

  return (
    <ListLayout>
      {(isFetching || isFetching2 || isFetching3) && <LoadingDialog />}
      {(isDownloading || isNoStockExporting || isExportingAll) && <ExportDialog />}
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Picking Unassigned"
              count={tabs.find((x) => x.label === "PickingUnassigned")?.count ?? 0}
              type={"picking-unassigned"}
              column={orderQtyColumns}
              selected={dashboardType === "picking-unassigned"}
              color={"#bdf9f9"}
              handleClick={handleClick}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Picking Assigned - Single"
              count={tabs.find((x) => x.label === "PickingAssignedSingle")?.count ?? 0}
              type={"picking-assigned-single"}
              column={pickedQtyColumns}
              selected={dashboardType === "picking-assigned-single"}
              handleClick={handleClick}
              color={"lightcyan"}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Picking Assigned - Wave"
              count={tabs.find((x) => x.label === "PickingAssignedWave")?.count ?? 0}
              type={"picking-assigned-wave"}
              column={pickedQtyColumns}
              selected={dashboardType === "picking-assigned-wave"}
              handleClick={handleClick}
              color={"#d9d9ff"}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Packing"
              count={tabs.find((x) => x.label === "Packing")?.count ?? 0}
              type={"packing"}
              column={pickedQtyColumns}
              selected={dashboardType === "packing"}
              handleClick={handleClick}
              color={"#C1ECFA"}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Awaiting Dispatch"
              count={tabs.find((x) => x.label === "AwaitingDispatch")?.count ?? 0}
              type={"awaiting-dispatch"}
              column={pickDOWithCancelColumns}
              selected={dashboardType === "awaiting-dispatch"}
              handleClick={handleClick}
              color={"lightyellow"}
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3} sx={{ "padding-top": "0px" }}>
        <Grid container spacing={3}>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Out For Delivery"
              count={tabs.find((x) => x.label === "OutFromWarehouse")?.count ?? 0}
              type={"out-from-warehouse"}
              column={pickDOManifestWithCancelColumns.filter(
                (x) => x.accessorKey !== "pendingSince"
              )}
              selected={dashboardType === "out-from-warehouse"}
              handleClick={handleClick}
              color={"bisque"}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title={"Completed"}
              count={tabs.find((x) => x.label === "Completed")?.count ?? 0}
              type={"completed"}
              column={pickDOManifestColumns.filter((x) => x.accessorKey !== "pendingSince")}
              selected={dashboardType === "completed"}
              color={"#bff8d9"}
              handleClick={handleClick}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="No Stock"
              count={tabs.find((x) => x.label === "NoStock")?.count ?? 0}
              type={"no-stock"}
              column={pickedQtyColumns}
              selected={dashboardType === "no-stock"}
              handleClick={handleClick}
              color={"#fdfdc1"}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Cancelled"
              count={tabs.find((x) => x.label === "Cancelled")?.count ?? 0}
              type={"cancelled"}
              column={orderQtyColumns.filter((x) => x.accessorKey !== "pendingSince")}
              selected={dashboardType === "cancelled"}
              color={"lightpink"}
              handleClick={handleClick}
            />
          </Grid>
          <Grid item xs={2.4}>
            <DefaultStatisticsCard
              title="Filter By Cust Ord Nbr"
              type={"filterCustOrdNbr"}
              column={allColumns}
              selected={dashboardType === "filterCustOrdNbr"}
              color={"#acdbfa"}
              handleClick={handleClick}
            />
          </Grid>
        </Grid>
      </MDBox>

      {/*dashboardType in full, PendingASN_custCode_currentDateTime */}
      {/*completed and cancelled also use currentDateTime, not startDate_endDate */}
      <TableCard>
        <Grid container justifyContent="space-between" alignItems="flex-start" margin="10px">
          {dashboardType === "filterCustOrdNbr" && (
            <Grid item xs={12} sx={{ marginRight: "20px", marginBottom: "10px" }}>
              <TextField
                label="Search Cust Ord Nbr (split by comma ,) - Max 10"
                fullWidth
                value={custOrdNbrs}
                onChange={(e) => setCustOrdNbrs(e.target.value)}
              />
            </Grid>
          )}
          <Grid item xs={3}>
            <MDBox display="flex" gap={1}>
              {dashboardType === "no-stock" && (
                <MDButton color="info" onClick={handleNoStockExportClick}>
                  export
                </MDButton>
              )}
              {dashboardType !== "no-stock" && (
                // <MDButton color="info">
                //   <CSVLink
                //     style={{ color: "white" }}
                //     filename={
                //       `${dashboardType}_Sales_${customerCode}_` +
                //       dayjs(new Date()).format("DD-MM-YYYY")
                //     }
                //     data={filteredData}
                //   >
                //     export
                //   </CSVLink>
                // </MDButton>
                <MDButton
                  color="info"
                  onClick={() => {
                    const filename = `${customerCode}_${dayjs(new Date()).format(
                      "YYYYMMDD-HHmm"
                    )}_Sales_${dashboardType}`;
                    const data = filteredData.map((x) => {
                      const {
                        orderDateStr,
                        receivedOnStr,
                        orderQuantityStr,
                        pickQtyStr,
                        shipmentCancelDateStr,
                        ...data
                      } = x;
                      return { ...data, custOrdNbr: "'" + x.custOrdNbr };
                    });
                    downloadCsv(filename, data);
                  }}
                >
                  export
                </MDButton>
              )}
              <MDButton color="secondary" onClick={handleExportAllClick}>
                export all
              </MDButton>
            </MDBox>
          </Grid>
          <Grid item xs={9}>
            <Grid justifyContent="flex-end" container spacing={3} sx={{ width: "100%" }}>
              <Grid item xs={3}>
                {dashboardType !== "filterCustOrdNbr" && (
                  <SelectFields
                    field={{ name: "", label: "Filter by Date", value: filterMethod, errors: {} }}
                    options={["Order Date", "Received On"]}
                    onChange={(e, v) => setFilterMethod(v)}
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                {dashboardType !== "filterCustOrdNbr" && <CustomDateRangePicker {...customProps} />}
              </Grid>
              <Grid item>
                <MDButton
                  color="info"
                  disabled={dashboardType === "filterCustOrdNbr" && !Boolean(custOrdNbrs)}
                  onClick={() => {
                    if (dashboardType === "filterCustOrdNbr") {
                      if (!clicked) setClicked(true);
                      else refetch3();
                    } else refetch();
                  }}
                >
                  search
                </MDButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <BasicTable columns={columns} data={data} onFilterRowsChange={handleFilterRowsChange} />
      </TableCard>
    </ListLayout>
  );
}

export default SalesDashboard;
